import { $t } from '@/i18n';
import { defineComponent, toRefs } from '@vue/composition-api';
import './index.scss';
import { getProps } from '@components/simpleModal/openSimpleModal';
import { getDocLink } from '@/utils/links';
import { toggleCliHttps } from '@/config/cli-settings';
const chromeTips = [
    {
        type: 'console-error',
        args: {
            console: 'GET http://localhost:port/ net::ERR_CONNECTION_REFUSED',
        },
        solutions: [{
                text: $t('k_be33ba71'),
            }],
    },
    {
        type: 'console-error',
        args: {
            console: 'GET http://localhost:port/ net::ERR_EMPTY_RESPONSE',
        },
        solutions: [{
                text: $t('k_3280a516'),
                btnText: $t('k_4050befb'),
                btnAction: () => {
                    toggleCliHttps(true, { reload: true });
                },
            }],
    },
    {
        type: 'console-error',
        args: {
            console: 'GET https://localhost:port/ net::ERR_SSL_PROTOCOL_ERROR',
        },
        solutions: [{
                text: $t('k_4aafc102'),
                btnText: $t('k_22614c2f'),
                btnAction: () => {
                    toggleCliHttps(false, { reload: true });
                },
            }, {
                text: $t('k_977bee88'),
                btnText: $t('k_69809c15'),
                btnAction: () => {
                    window.open(getDocLink().HTTPS_DEVTOOL);
                },
            }],
    },
    {
        type: 'console-error',
        args: {
            console: 'Failed to load resource:net::ERR_SSL_PROTOCOL_ERROR',
        },
        solutions: [{
                text: $t('k_816f4da'),
                btnText: $t('k_671d3581'),
                btnAction: () => {
                    window.location.href = window.location.href.replace(/^https/, 'http');
                },
            }],
    },
    {
        type: 'console-error',
        args: {
            console: 'blocked by CORS policy: The request client is not a secure context and the resource is in more-private address space `local`',
        },
        solutions: [{
                image: 'https://vfiles.gtimg.cn/vupload/20211019/7e61b91634629215335.png',
                // i18n ignore next line
                text: '浏览器禁止请求localhost，请打开 <span class="highlight-font">chrome://flags/#block-insecure-private-network-requests </span> 设置 Block insecure private network requests 为 disabled',
            }],
    },
];
const tips = navigator.userAgent.includes('Chrome') ? chromeTips : null;
export default defineComponent({
    name: 'localLoadErrorModal',
    props: {
        ...getProps(),
    },
    setup(props) {
        const { context } = toRefs(props);
        return {
            debugType: context.value?.debugType || $t('k_91f3e981'),
            tips,
        };
    },
    render() {
        return (<a-modal visible={true} ok-text={$t('k_a5064e7f')} class="local-load-error-modal" cancel-text={$t('k_83ed1744')} centered title={$t('k_f426d5ff', { arg_0: this.debugType })} width="800px" onOk={this.onSuccess} onCancel={this.onCancel}>
        {this.tips ? (<div class="content-box">
            {$t('k_e5c96995')}
            {this.tips.map((item, index) => (<div class="content-item">
                <div>
                  <a-icon class="content-item-icon" type="exclamation-circle"/>
                  {$t('k_a2cdd30b')}{index + 1} {$t('k_ae5a5c54')}
                  <div class="console-error">{item.args.console}</div>
                </div>
                {item.solutions.map((solution, index) => (<div class="contenet-item-solution">
                  <a-icon class="content-item-icon" type="alert"/>
                  {$t('k_8a3cf94f')}{index + 1}：<span domPropsInnerHTML={solution.text}></span>
                  {solution.btnText ? (<a-button type="link" onClick={solution.btnAction}>
                      {solution.btnText}
                    </a-button>) : null}
                  {solution.image ? <img class="pic" src={solution.image}/> : null}
                </div>))}
               </div>))}
          </div>) : ($t('k_71f8a256'))}
      </a-modal>);
    },
});
